export enum ButtonsCustom {
    Button_01 = 'BUTTON_01',
    Button_02 = 'BUTTON_02',
    Button_03 = 'BUTTON_03',
}
